<template>
            <div id="mobile-menu">
                <div class="header__mobile mobile-menu " :class="burgerMenu ? 'mobile-menu_active': ''"  >
                    <div class="mobile-menu__wrapper">
                        <div class="mobile-menu__header">
                            <div class="mobile-menu__hide-logo">
                                <img class="mobile-menu__hide-logo-img" :src="'/img/svg/logo.svg'">
                            </div>
                            <div class="mobile-menu__search-btn" @click="searchBlock = !searchBlock">
                                <svg class="svg-icon" width="16" height="16" viewBox="0 0 16 16" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M7.25 12.5C10.1495 12.5 12.5 10.1495 12.5 7.25C12.5 4.35051 10.1495 2 7.25 2C4.35051 2 2 4.35051 2 7.25C2 10.1495 4.35051 12.5 7.25 12.5Z"
                                        stroke="black" stroke-linecap="round" stroke-linejoin="round"></path>
                                    <path d="M10.9619 10.9624L13.9994 13.9999" stroke="black" stroke-linecap="round"
                                          stroke-linejoin="round"></path>
                                </svg>
                                <p class="mobile-menu__search-btn-text">{{ trans('Search') }}</p>
                            </div>
                            <div class="mobile-menu__close" @click="burgerMenu = !burgerMenu;searchBlock = false">
                                <svg class="svg-icon" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path d="M18.75 5.25L5.25 18.75" stroke="black" stroke-linecap="round"
                                          stroke-linejoin="round"></path>
                                    <path d="M18.75 18.75L5.25 5.25" stroke="black" stroke-linecap="round"
                                          stroke-linejoin="round"></path>
                                </svg>
                            </div>
                        </div>
                        <nav class="mobile-menu__top-nav" v-if="!searchBlock">
                            <ul class="list mob-top-nav-list">

                                <li class="list__element mob-top-nav-list__element ">
                                    <a :href="maleCatalogPath" :class="$parent.gender === 'male' ? 'router-link-active':''"  @click="burgerMenu = false;searchBlock = false"
                                                 class="mob-top-nav-list__link">{{ trans('Male')}}</a>
                                </li>

                                <li class="list__element mob-top-nav-list__element">
                                    <a :href="femaleCatalogPath" :class="$parent.gender === 'female' ? 'router-link-active':''"  @click=";burgerMenu = false;searchBlock = false"
                                                 class="mob-top-nav-list__link">{{ trans('Female')}}</a>
                                </li>
                                <template v-if="isTopMenuView">
                                    <li class="list__element mob-top-nav-list__element" v-if="this.$store.state.settings.site_id == 1">
                                        <a href="/stores" class="mob-top-nav-list__link" @click="burgerMenu = false;searchBlock = false">{{ trans('Stores')}}</a>
                                    </li>
                                    <li class="list__element mob-top-nav-list__element">
                                        <a href="/about" class="mob-top-nav-list__link" @click="burgerMenu = false;searchBlock = false">{{ trans('About the brand')}}</a>
                                    </li>
                                </template>
                            </ul>
                            <ul class="list mob-top-nav-list" v-if="showSecretLink()">
                                <template v-if="isTopMenuView">
                                    <li class="list__element mob-top-nav-list__element">
                                        <a href="/secret" class="mob-top-nav-list__link" @click="burgerMenu = false;searchBlock = false">{{trans('Secret')}}</a>
                                    </li>
                                </template>
                            </ul>
                        </nav>

                        <div class="mobile-menu__body" v-if="!searchBlock">
                            <nav class="mobile-menu__main-nav" v-if="menus">
                                <div class="mobile-menu__logo">
                                    <img class="mobile-menu__logo-img" :src="'/img/svg/logo.svg'"
                                         alt="">
                                </div>
                                <ul class="list main-nav-mob-list">

                                    <li class="list__element main-nav-mob-list__element " v-for="menu in menus.filter((item) => item.visible)" :key="menu.id">
                                        <a :href="`/catalog/${$parent.gender}/${menu.link}`" :key="menu.id" @click="burgerMenu = false"
                                                     class="main-nav-mob-list__link">
                                            {{ menu.category_name }}
                                        </a>

                                    </li>



                                </ul>
                            </nav>

                            <div class="mobile-menu__contacts">
                                <nav class="footer__nav">
                                    <ul class="list footer-nav-list">
                                        <li class="list__element footer-nav-list__element">
                                            <a class="footer-nav-list__link" href="/contacts" @click="burgerMenu = false;searchBlock = false">{{ trans('Contacts') }}</a>
                                        </li>
                                        <li class="list__element footer-nav-list__element">
                                            <a class="footer-nav-list__link" href="/public-offer" @click="burgerMenu = false;searchBlock = false">{{ trans('Info') }}</a>
                                        </li>
                                    </ul>
                                </nav>

                                <p class="footer__phone_row" v-if="this.$store.state.settings.site_id == 1">
                                    <a href="tel:+74997034020" class="footer__phone">+7 (499) 703-40-20</a>
                                    <span class="footer__phone-line">—</span>
                                    <span>{{ trans('from 10 to 21 every day') }}</span>
                                </p>

                                <div class="footer__network_row">
                                    <Socials />
                                </div>

                                <p class="footer__copy">©2009-{{new Date().getFullYear()}}. {{ trans('All rights reserved') }}</p></div>
                        </div>
                        <div class="mobile-menu__search-wrapper search-mob" v-if="searchBlock" style="display: flex">
                            <div class="search-mob__field">
                                <div class="search-mob__ic" @click="searchCards">
                                    <svg class="svg-icon" width="16" height="16" viewBox="0 0 16 16" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M7.25 12.5C10.1495 12.5 12.5 10.1495 12.5 7.25C12.5 4.35051 10.1495 2 7.25 2C4.35051 2 2 4.35051 2 7.25C2 10.1495 4.35051 12.5 7.25 12.5Z"
                                            stroke="black" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <path d="M10.9619 10.9624L13.9994 13.9999" stroke="black" stroke-linecap="round"
                                              stroke-linejoin="round"></path>
                                    </svg>
                                </div>
                                <input v-model="search" @keyup.enter="searchCards" type="text" :placeholder="trans('Search')" class="input-element search-mob__input" >
                                <div class="search-mob__close" @click="searchBlock =! searchBlock;searchBlock = false">
                                    <svg class="svg-icon" width="16" height="16" viewBox="0 0 16 16" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12.5 3.5L3.5 12.5" stroke="#9B9FA1" stroke-linecap="round"
                                              stroke-linejoin="round"></path>
                                        <path d="M12.5 12.5L3.5 3.5" stroke="#9B9FA1" stroke-linecap="round"
                                              stroke-linejoin="round"></path>
                                    </svg>
                                </div>
                            </div>
                            <ul class="list mob-top-nav-list">

                                <li class="list__element mob-top-nav-list__element ">
                                    <span   @click="searchGender = 'male'" :class="searchGender === 'male'  ? 'router-link-active' :''"
                                                 class="mob-top-nav-list__link" >{{ trans('Male') }}</span>
                                </li>
                                <li class="list__element mob-top-nav-list__element ">
                                        <span   @click="searchGender = 'female'" :class="searchGender === 'female'  ? 'router-link-active' :''"
                                               class="mob-top-nav-list__link" >{{ trans('Female') }}</span>
                                </li>

                            </ul>

                        </div>
                    </div>
                </div>
            </div>

</template>

<script>
import Socials from '@/src/components/Socials.vue';

export default {
    components: {Socials},
    props: {
        menus: {
            type: Object,
        },


    },
    data(){
        return{
            burgerMenu:false,
            searchBlock : false,
            search:'',
            searchGender: this.$store.state.settings.gender,
        }
    },
    computed: {
        maleCatalogPath() {
            return this.$store.state.settings.protected_page ? import.meta.env.VITE_MALE_CATALOG_PATH : '/catalog/male';
        },
        femaleCatalogPath() {
            return this.$store.state.settings.protected_page ? import.meta.env.VITE_FEMALE_CATALOG_PATH : '/catalog/female';
        },
        isTopMenuView() {
            return !this.$store.state.settings.protected_page
        },
        hasSecretInUrl() {
            return window.location.href.includes('secret')
        }
    },
    methods:{
        searchCards(search = null){
            this.burgerMenu = false
            this.searchBlock = false
            let url = `/search?search=${encodeURIComponent(this.search.trim())}`;
            if (this.searchGender) {
                url += `&gender=${encodeURIComponent(this.searchGender)}`;
            }
            window.location.href = url;
            this.search = ''
        },
    showSecretLink() {
        if (this.hasSecretInUrl) {
            return false
        }
        if (this.$store.state.settings.site_id == 1 && this.$store.state.settings?.secret?.stage != 0) {
            return true
        } else if(this.$store.state.settings.site_id == 2 && this.$store.state.settings?.secret?.stage != 0) {
            return true
        }
        return false
    }
    },
    mounted() {

    },
    name: "MobilMenu"
}
</script>

<style scoped>

</style>
